module.exports = __webpack_public_path__ + "img/MechD-white.df093072.png";